import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { Selectize, Fieldset } from '~/components/FormControl';
import PropTypes from 'prop-types';
import CardBack from '~/components/CardMaker/components/CardBack';
import { API_PREFIX } from '~/pages/CardSaga/ActionCard/actionCard.api';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import CardMaker from '~/components/CardMaker';
import isEmpty from 'lodash/isEmpty';
import { renderCardFrontEdit } from '~/components/CardMaker/components/CardFrontEdit/render-card-front';

function CardInformation({ values }) {
    const { cardMetaData, resetCount, backSides } = useFormTab();
    const { keywords, actions, powers } = cardMetaData;
    const { name } = values;

    return (
        <>
            <Fieldset sm={12}>
                <Fieldset.Legend>Card Maker</Fieldset.Legend>
                <CardMaker
                    apiPrefix={API_PREFIX}
                    values={values}
                    renderCardFrontEdit={renderCardFrontEdit({ name })}
                    iconOrCrop={'icon'}
                />
            </Fieldset>

            {!isEmpty(cardMetaData) && (
                <Form.Row>
                    <Selectize
                        sm="3"
                        name="keywords"
                        options={keywords ?? []}
                        note="* only published keywords are available for selection."
                    />
                    <Selectize
                        as={Col}
                        sm="4"
                        name="replacements"
                        options={[...actions, ...powers] || []}
                        tooltip="Card to replace during upgrade phase."
                    />
                </Form.Row>
            )}
        </>
    );
}

CardInformation.propTypes = {
    values: PropTypes.object.isRequired,
};
export default CardInformation;
